export const EstimateContents = {
  DESCRIPTION_1:
    "Twisted Nail Sand & Gravel is partnered with nearly 100 Central Texas quarries and over 150+ local aggregate trucks, ensuring your team has immediate access to the most complete aggregate supply and disposal network in the area. Working with Twisted Nail is straight-forward and is catered to the needs of your project. To place an order, your project manager will text or call their assigned TN sales representative 1-2 days before their material is needed with the details of their order. From there, our team will arrange for turnkey delivery and will keep your team informed as the job progresses.",
  DESCRIPTION_2:
    "All trucking estimates are provided assuming current equipment availability, fuel prices, and other market conditions; estimates are subject to change due to unforeseen changes in local market conditions. All material estimates are provided pre-tax. Unless otherwise specified by written agreement, all commercial estimates assume 6 hours of continuous delivery; a +20.0% spot rate surcharge will be added to any orders that do not meet the 6-hour minimum.",
  PAYMENT_TERMS:
    "We accept payment via Cash, Company Check, Cashier's Check, Credit Card, Wire and ACH Transfers. Charge accounts are available to qualified accounts and are reviewed on a per project basis. A completed Project Information Sheet and acceptance of our provided terms is required prior to a charge account being established.",
  THANK_YOU:
    "We are grateful for the opportunity to submit this aggregate supply estimate. Please let us know how we can be of service.",
};

export const QuoteContents = {
  DESCRIPTION:
    "All material quotes are provided pre-tax; tax will be applied on all taxable sales unless a current sales tax exemption certificate has been provided to the Twisted Nail accounting team. All material estimates are provided pre-tax. Unless otherwise specified by written agreement, all commercial quotes assume 6 hours of continuous delivery; a +20.0% spot rate surcharge will be added to any orders that do not meet the 6-hour minimum. Our aggregates are dug from the Texas Earth, processed, and delivered wholesale to our customers. Wholesale aggregate deliveries will vary in coloring and in material consistency. As a result, we are unable to guarantee specific coloring and other aesthetic properties beyond those required by testing guidelines. Central Texas quarries do not regularly carry testing reports on any materials. Testing of all materials is the responsibility of the end customer. To help facilitate the testing process, buckets of sample material can be delivered to your team or chosen testing facility upon request.",
  PAYMENT:
    "Payment for services is required prior to delivery. We accept payment via Cash, Cashier’s Check, Credit Card, Wireand ACH Transfers.",
  SIGNATURE:
    "By signing this document, you are attesting that you are an authorized representative of the signing company, orthat you are ordering onbehalf of yourself as an individual, and that you agree to the terms of this agreement.",
};

export const QuoteMockData = {
  agreementDescription:
    "All material quotes are provided pre-tax; tax will be applied on all taxable sales unless a current sales tax exemption certificate has been provided to the Twisted Nail accounting team. All material estimates are provided pre-tax. Unless otherwise specified by written agreement, all commercial quotes assume 6 hours of continuous delivery; a +20.0% spot rate surcharge will be added to any orders that do not meet the 6-hour minimum. Our aggregates are dug from the Texas Earth, processed, and delivered wholesale to our customers. Wholesale aggregate deliveries will vary in coloring and in material consistency. As a result, we are unable to guarantee specific coloring and other aesthetic properties beyond those required by testing guidelines. Central Texas quarries do not regularly carry testing reports on any materials. Testing of all materials is the responsibility of the end customer. To help facilitate the testing process, buckets of sample material can be delivered to your team or chosen testing facility upon request.",
  paymemtTerms:
    "Payment for services is required prior to delivery. We accept payment via Cash, Cashier’s Check, Credit Card, Wireand ACH Transfers.",
  signature:
    "By signing this document, you are attesting that you are an authorized representative of the signing company, orthat you are ordering onbehalf of yourself as an individual, and that you agree to the terms of this agreement. This is the testing para - signed by aathi",
  print_name: "Twisted Nail",
  title: "Twisted Nail",
  phone: "Test",
  email: "twistednail@ex.com",
  date: "29/04/2025",
  img_url:
    "https://thanush-s3.s3.ap-south-1.amazonaws.com/public/quotes/384_Test+Job+-+Trucking+Job+(2)_quote.pdf",
  img_text: "Customer Name",
};

export const QuoteFields = {
  email: "Email",
  phone: "Phone",
  printname: "Print Name",
  title: "Title",
  date: "Date",
  paymentHeader: "Payment Terms",
  signatureHeader: "Signature",
  signedFor: "Signed for",
};

export const QuoteEditablesPlaceHolders = {
  signaturePlaceHolder: "Enter Signature *",
  printNamePlaceHolder: "Enter print name *",
  titlePlaceHolder: "Enter Title *",
  phonePlaceHolder: "Enter Phone Number *",
  emailPlaceHolder: "Enter Email *",
  datePlaceHolder: "Enter Date *",
  paymentPlaceHolder: "Enter payment terms",
  siganturePlaceHolder: "Enter signature terms",
};

export const fieldNames = {
  QUOTE_HEADER: "quoteHeader",
  ESTIMATE_HEADER: "estimateHeader",
  QUOTE_PRINT_NAME: "quotePrintName",
  QUOTE_TITLE: "quoteTitle",
  QUOTE_PHONE: "quotePhone",
  QUOTE_EMAIL: "quoteEmail",
  QUOTE_DATE: "quoteDate",
  QUOTE_TEXT_AREA_INTRO: "quoteTextAreaIntro",
  QUOTE_PAYMENT_TERMS: "quotePaymentTerms",
  QUOTE_SIGNATURE: "quoteSignature",
  SIGN_IMAGE_SRC: "signImageSrc",
  SIGN_TEXT: "signatureText",
  COMPANY_NAME: "companyName",
  PROJECT_NAME: "projectName",
  CONTACT: "contact",
  CONTACT_LAST_NAME: "contactLastName",
  EMAIL: "email",
  CUSTOMER_ACCOUNT: "customerAccount",
  SALES_PERSON: "salesPerson",
  DELIVERY_ADDRESS: "deliveryAddress",
  DELIVERY_COORDINATES: "deliveryAddressCoordinates",
  ESTIMATE_AGGREGATE_SUPPLY_1: "estimateAggregateSupply1",
  ESTIMATE_AGGREGATE_SUPPLY_2: "estimateAggregateSupply2",
  ESTIMATE_PAYMENT_TERMS: "estimatepaymentTerms",
  ESTIMATE_THANK_YOU: "estimateThankYou",
  TEMPLATE_COMPANY_NAME: "templateCompanyName",
  TEMPLATE_COMPANY_ADDRESS: "templateCompanyAddress",
  TEMPLATE_COMPANY_CONTACT: "templateCompanyContact",
  ESTIMATE_COMPANY_NAME: "estimateCompanyName",
  ESTIMATE_COMPANY_ADDRESS: "estimateCompanyAddress",
  ESTIMATE_COMPANY_CONTACT: "estimateCompanyContact",
  TEMPLATE_ADDRESS_HEADER: "templateAddressHeader",
  ESTIMATE_ADDRESS_HEADER: "estimateAddressHeader",
};

export const getDocumentRows = (data: DocumentType, type: string) => {
  return data?.data?.[type]?.map?.((content) => {
    return {
      ...content,
      label: content?.templateName,
      value: content?.id,
      key: content?.id,
    };
  });
};

export const ModalConstants = {
  jobLabel: "Job Name",
  jobPlaceholder: "Select Job",
};

export const hasFormChanged = (payload, initialDetails) => {
  if (!initialDetails) {
    return true;
  }
  const normalize = (value) => {
    if (typeof value === "string") {
      return value?.trim();
    }
    return value ?? "";
  };

  const fieldMap = [
    // Quote Fields
    { p: "quote_print_name", i: "quote_print_name" },
    { p: "quote_title", i: "quote_title" },
    { p: "quote_phone", i: "quote_phone" },
    { p: "quote_email", i: "quote_email" },
    { p: "companyName", i: "companyName" },
    { p: "companyAddress", i: "companyAddress" },
    { p: "companyContact", i: "companyContact" },
    { p: "quoteAddressTerms", i: "quoteAddressTerms" },
    { p: "quoteHeader", i: "quoteHeader" },
    { p: "quote_agreementDescription", i: "quote_agreementDescription" },
    { p: "quote_paymemtTerms", i: "quote_paymemtTerms" },
    { p: "quote_signature", i: "quote_signature" },

    // Estimate Fields
    { p: "estimate_companyName", i: "estimate_companyName" },
    { p: "estimate_companyAddress", i: "estimate_companyAddress" },
    { p: "estimate_companyContact", i: "estimate_companyContact" },
    { p: "estimateHeader", i: "estimateHeader" },
    { p: "estimateAddressTerms", i: "estimateAddressTerms" },
    { p: "estimate_agreementSectionTop", i: "estimate_agreementSectionTop" },
    {
      p: "estimate_agreementSectionBottom",
      i: "estimate_agreementSectionBottom",
    },
    { p: "estimate_paymentTerms", i: "estimate_paymentTerms" },
    { p: "estimate_thanksNotes", i: "estimate_thanksNotes" },

    {
      p: "quote_date",
      i: "quote_date",
      transform: (val) => val?.split(" ")?.join(""),
    },
    {
      p: "img_url",
      i: "img_url",
      transform: (val) => val?.split("?")?.[0],
    },
  ];

  for (const field of fieldMap) {
    if (field.p in payload) {
      let payloadValue = normalize(payload?.[field.p]);

      let initialValue = initialDetails?.[field.i];
      if (field.transform) {
        initialValue = field.transform(initialValue);
        payloadValue = field.transform(payloadValue);
      }
      const normalizedInitialValue = normalize(initialValue);
      if (payloadValue !== normalizedInitialValue) {
        return true;
      }
    }
  }
  return false;
};
